import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Grid, Container, Box } from '@mui/material';
import PedidosNavbar from './PedidosNavbar'
import BottomButtons from '../../pages/pedidos/components/BottomButtons';

const RootStyle = styled('div')(({ theme }) => ({
	height: '100%',
	padding: '80px 0px 50px 0px'
}));

export default function DetalhesLayout() {
	return <>
		<PedidosNavbar menu={false} title='Detalhes' />
		<RootStyle>
			<Grid container justifyContent='center' sx={{ height: '100%' }} >
				<Grid item xs={12} md={4} >
					<Container >
						<Outlet />
					</Container>
				</Grid>
				<Box sx={{ height: '90px', width: '100%' }}>
					<BottomButtons />
				</Box>
			</Grid>
		</RootStyle>
	</>
}
